<!-- @format -->
<template>
    <div class="columns is-marginless">
        <div class="column is-paddingless">
            <post :post="post" :is-top-post="isTopPost" :show-snippet="false">
                <span slot="mainLabel"><fa-icon icon="video" /> {{ post.post_type.value }}</span>
            </post>
        </div>
    </div>
</template>

<script>
import Post from './Post.vue';

export default {
    components: {
        Post
    },

    props: {
        post: {
            type: Object,
            required: true
        },
        isTopPost: {
            type: Boolean,
            default: false
        }
    }
};
</script>
